"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { Controller } from "@hotwired/stimulus";
export default class controller_default extends Controller {
  open() {
    this.setOpen(true);
  }
  close() {
    if (this.element.dataset.searchOpen === "true") {
      this.setOpen(false);
    }
  }
  setOpen(open) {
    this.element.dataset.searchOpen = String(open);
    this.toggleTarget.setAttribute("aria-expanded", String(open));
    const focusTarget = open ? this.inputTarget : this.toggleTarget;
    focusTarget.focus();
  }
}
__publicField(controller_default, "targets", ["toggle", "input"]);
